export default {
  dashboardSettings_set (state, settings) {
    state.dashboardSettings = Object.assign(state.dashboardSettings_initial, settings || {})
  }
}
